import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';

import { AddLayerSelectionType, AddLayerService, TableInfo } from '@connect-services/client/services/add-layer.service';
import { CheckboxComponent, CheckboxState } from '@connect-services/src/lib/components/checkbox/checkbox.component';
import { SelectComponent, SelectOption } from '@connect-services/src/lib/components/select/select.component';
import { RessourcesModule } from '@ressources/client/ressources.module';
import { LoadingComponent } from '@shared/client/components/loading/loading.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CheckboxComponent, LoadingComponent, RessourcesModule, SelectComponent],
    selector: 'app-select-layer-step',
    templateUrl: './select-layer-step.component.html',
})
export class SelectLayerStepComponent {
    public readonly allTablesByDeposit = input<Record<string, TableInfo[]> | undefined>(undefined);
    public readonly handlePreselection = output<void>();
    public readonly isLayerPreset = input<boolean>(false);
    public readonly isTableLoading = input<boolean>(false);
    public readonly selectedLayerType = input<AddLayerSelectionType | undefined>(undefined);

    protected readonly addLayerService = inject(AddLayerService);
    protected readonly CheckboxState = CheckboxState;
    protected readonly defaultLayers = computed<SelectOption<TableInfo>[]>(() =>
        this.addLayerService.getDefaultListValue(
            this.addLayerService.tableOptions(),
            this.addLayerService.selectedTablesInfo(),
        ),
    );
    protected readonly hasSelectableLayers = computed<boolean>(() => {
        const selectedDeposit = this.addLayerService.selectedDeposit();

        return !!(
            (selectedDeposit && this.allTablesByDeposit()?.[selectedDeposit]?.length) ||
            this.addLayerService.interstandards().length ||
            this.addLayerService.availableSourceLayers().length
        );
    });
    protected readonly isLayerPreselectionEnabled = computed<boolean>(() => {
        return (
            !this.addLayerService.depositStandard() && this.selectedLayerType() !== AddLayerSelectionType.REFERENCE_DATA
        );
    });
    protected readonly shouldDisplayPreselection = computed<boolean>(() => {
        const selectedLayerType = this.selectedLayerType();

        return (
            !!selectedLayerType &&
            (selectedLayerType === AddLayerSelectionType.TABLE ||
                selectedLayerType === AddLayerSelectionType.REFERENCE_DATA) &&
            !!this.addLayerService.layersPresetsExtended().length
        );
    });

    public selectTable(tableNames: TableInfo[]): void {
        this.addLayerService.selectedTablesInfo.set(tableNames);
    }
}
